import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';

export const IS_LOADING = 'IS_LOADING';
export const FETCH_REPORT_STATUS_LIST =
	'SOUND_DEFETCH_REPORT_STATUS_LISTTAILS_LOADING';
export const FETCH_CALL_SOURCE = 'FETCH_CALL_SOURCE';
export const FETCH_CALL_TYPE_LIST = 'FETCH_CALL_TYPE_LIST';
export const FETCH_CALL_TYPE_SOURCE_LIST = 'FETCH_CALL_TYPE_SOURCE_LIST';
export const FETCH_CALL_STATUS_LIST = 'FETCH_CALL_STATUS_LIST';
export const FETCH_IVR_FLOW_NAME = 'FETCH_IVR_FLOW_NAME';
export const FETCH_REPORT_LIST = 'FETCH_REPORT_LIST';
export const FETCH_NEW_REPORT_LIST = 'FETCH_NEW_REPORT_LIST';
export const FETCH_CAMPAIGN_NAMES = 'FETCH_CAMPAIGN_NAMES';
export const FETCH_FILTERED_NEW_LIST = 'FETCH_FILTERED_NEW_LIST';

export const FETCH_SPEECH_CALL_TYPE_LIST = 'FETCH_SPEECH_CALL_TYPE_LIST';
export const FETCH_SPEECH_STATUS_LIST    = 'FETCH_SPEECH_STATUS_LIST';
export const ANALYTICS_REPORT_ERROR      = 'ANALYTICS_REPORT_ERROR';
export const FETCH_HANGUP_STATUS_LIST    = 'FETCH_HANGUP_STATUS_LIST';
export const FETCH_SYSTEM_DISPO_LIST     = 'FETCH_SYSTEM_DISPO_LIST';


export const getReportStatusList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/reports-status`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_REPORT_STATUS_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error, },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getCallSourceList = () => {
	return (dispatch: Dispatch<any>) => {
        dispatch({ type: IS_LOADING, payload: true });
		let endpoint = `/call-source`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_CALL_SOURCE,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getCallTypeSourceList = () => {
	return (dispatch: Dispatch<any>) => {
        dispatch({ type: IS_LOADING, payload: true });
		let endpoint = `/call-type-source`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_CALL_TYPE_SOURCE_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getCallTypeList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/call-type`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_CALL_TYPE_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};
export const getSpeechCallTypeList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/speech-call-type`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_SPEECH_CALL_TYPE_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getReportFieldList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/call-type`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_CALL_TYPE_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getCallStatusList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/call-status`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_CALL_STATUS_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};
export const getSpeechStatusList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/speech-status`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_SPEECH_STATUS_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getHangupStatusList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/hangup-status`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_HANGUP_STATUS_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getSystemDispoList = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/system-dispo`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_SYSTEM_DISPO_LIST,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getIVRFlowName = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/flow-name-filter`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_IVR_FLOW_NAME,
						payload: { res: res.data },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getReportList = (limit: number, offset: number, filterData?: any,) => {
	return (dispatch: Dispatch<any>) => {
        dispatch({ type: IS_LOADING, payload: true });

        // if (offset === 0) {
        //     dispatch({
        //         type: FETCH_NEW_REPORT_LIST,
        //         payload: { res: [] },
        //     });
        // }
        let endpoint = `/report?limit=${limit}&offset=${offset * limit}`;
        if (filterData) {
            if (Object.keys(filterData).length && Object.keys(filterData).length > 0) {
                Object.keys(filterData).forEach((key, index) => {
                    if (filterData[key] && filterData[key] !== '') {
                        endpoint = `${endpoint}&${key}=${filterData[key]}`
                    }
                });
            }
        }

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {

                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
                    if (filterData && Object.keys(filterData).length > 0 && offset === 0) {
                        dispatch({
                            type: FETCH_FILTERED_NEW_LIST,
                            payload: { res: res.data, total: res.total },
                        });
                    } else if (offset === 0) {
                        dispatch({
                            type: FETCH_NEW_REPORT_LIST,
                            payload: { res: res.data, total: res.total },
                        });
                    }
					else {
                        dispatch({
                            type: FETCH_REPORT_LIST,
                            payload: { res: res.data, total: res.total },
                        });
                    }
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error, },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const getCampaignNames = () => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

        let endpoint = `/campaign-names`;

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_CAMPAIGN_NAMES,
						payload: { res: res.data.campaign_names },
					});
				} else {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error: res.error, },
					});
				}
			})
			.catch((error) => {
                dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: ANALYTICS_REPORT_ERROR,
						payload: { error },
					});
				}
			});
	};
};